import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  QSetReviewTaskCreationFormSchema,
  type QSetReviewTaskCreationFormInput,
} from '../../schemas';

interface QSetReviewTaskCreationFormProviderProps extends PropsWithChildren {
  initialValues?: QSetReviewTaskCreationFormInput;
}

export default function QSetReviewTaskCreationFormProvider(
  props: Readonly<QSetReviewTaskCreationFormProviderProps>,
) {
  const { initialValues, children } = props;

  const formContext = useForm<QSetReviewTaskCreationFormInput>({
    defaultValues: initialValues ?? {
      taskDetails: {
        name: '',
      },
    },
    resolver: zodResolver(QSetReviewTaskCreationFormSchema),
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
